import * as React from "react";
import * as S from "@styled";

export const SaveBar: React.FC<{ isShown: boolean, handleSave: () => void }> = ({ isShown, handleSave }) => {
    return <S.BottomBar isShown={isShown}>
        <S.FlexContainer centerItems={true} gap={50}>
            <h3>Unsaved changes</h3>
            <S.Button
                onClick={handleSave}
                variant={S.ButtonType.dark}
                id="save-changes-button"
            >
                {FRENDS.Localizations.SaveChanges}
            </S.Button>
        </S.FlexContainer>
    </S.BottomBar>
}